"use client";

import { useClerk } from "@clerk/nextjs";
import { useNativeSignIn } from "@/hooks/useNativeSignIn";
import styles from "./styles.module.scss";
import {
  Box as MantineBox,
  Text as MantineText,
  UnstyledButton as MantineUnstyledButton,
} from "@mantine/core";

const BlogSignUpCTA = () => {
  const { user } = useClerk();
  const { openSignIn } = useNativeSignIn();

  if (user) return null;

  return (
    <MantineBox className={styles.cta}>
      <MantineText className={styles.headline}>Keep finding great pieces.</MantineText>
      <MantineText className={styles.sub}>
        Join KURB to get alerts on the brands and items you actually care about, across every resale
        platform.
      </MantineText>
      <MantineUnstyledButton className={styles.button} onClick={() => void openSignIn()}>
        Join KURB, it&apos;s free
      </MantineUnstyledButton>
    </MantineBox>
  );
};

export default BlogSignUpCTA;
